import { render, staticRenderFns } from "./PurchaseInventory.vue?vue&type=template&id=97eec3fc&scoped=true"
import script from "./PurchaseInventory.vue?vue&type=script&lang=js"
export * from "./PurchaseInventory.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInventory.vue?vue&type=style&index=0&id=97eec3fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97eec3fc",
  null
  
)

export default component.exports